/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ResendInputs */

const en_resend = /** @type {(inputs: ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend`)
};

const de_resend = /** @type {(inputs: ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut senden`)
};

/**
* | output |
* | --- |
* | "Resend" |
*
* @param {ResendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const resend = /** @type {((inputs?: ResendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ResendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resend(inputs)
	return de_resend(inputs)
});